import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import partial from 'lodash/partial';
import { toggleStatsModal, getStats, getProject, fetchStatsIfNeeded } from 'project/ducks/project';
import { getProjectIdFromUrl } from 'project/utils';
import StatsModal from 'project/components/stats_modal';

const mapStateToProps = (state, { onAdmin }) => ({
  stats: getStats(state),
  project: onAdmin? state.admin.projects.currentProject : getProject(state),
});

const mapDispatchToProps = (dispatch, { params, onAdmin }) => {
  const projectId = onAdmin? params.projectId : getProjectIdFromUrl(params);

  return bindActionCreators({
    onClose: toggleStatsModal,
    fetchStatsIfNeeded: partial(fetchStatsIfNeeded, projectId)
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StatsModal));



// WEBPACK FOOTER //
// ./project/containers/stats_modal.js